import React from 'react';
import { useNavigate } from 'react-router-dom';
import useUserInfo from '@/components/Authenticate/useUserInfo';

type ProtectedRouteProps = {
  children: React.ReactNode;
  permissionKeys: string[];
};

const ProtectedRoute = ({ children, permissionKeys }: ProtectedRouteProps) => {
  const { userPermissions } = useUserInfo();
  const navigate = useNavigate()
  // Check if the user has at least one required permission
  const hasPermission = permissionKeys.some((key) => userPermissions?.[key] === 'CHECK_RESULT_ALLOWED');

  if (!hasPermission) {
    navigate('/')
    return <></>
  }

  return <>{children}</>;
};

export default ProtectedRoute;
